module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/报告下载端.9eacf572.png";